import React from 'react';
import Permissions from '../auth/Permissions';

export const getBody = ({
  ownerId,
  freeUserLimit = 4,
  userLimit = freeUserLimit,
  style = {},
  subscriptionOver,
}) => {
  if (Permissions.id === ownerId) {
    return (
      <div style={style}>
        If you need more than {subscriptionOver ? freeUserLimit : userLimit} active users, contact Ontraccr support.
      </div>
    );
  }
  return (
    <div>
      Contact your account owner to upgrade your account
    </div>
  );
};

export default (props) => {
  const {
    subscriptionOver,
    freeUserLimit = 4,
    userLimit = 4,
  } = props;
  return (<div style={{ maxWidth: 320, overflow:'hidden', overflowWrap:'break-word'}}>
    Your account is limited to {subscriptionOver ? freeUserLimit : userLimit} active users.
    <br/>
    <br/>
    {getBody(props)}
  </div>
);
}
